import { FleekError } from './FleekError';

type ObjectId = {
  id?: string;
};

type DomainZoneInPendingStateErrorOptions = {
  zone: ObjectId;
};

export class DomainZoneInPendingStateError extends FleekError<DomainZoneInPendingStateErrorOptions> {
  public name = 'ZoneInPendingStateError';

  toString = () => {
    return 'Domain zone is in pending state. Please wait and try action again later.';
  };
}
